import { isSudoziUrl, isUrl } from "@src/utils/string";
import React, { Fragment, ReactElement } from "react";
import { v4 } from "uuid";

export function WithHyperlink({
  str,
  className,
  as,
}: {
  str: string | undefined | null;
  className?: string;
  as: "div" | "span" | "p" | "label" | "i";
}): ReactElement {
  if (!str) return <></>;

  const As = as;

  // process links and new lines while preserving spaces
  const lines = str.split("\n");

  const withLinks = lines.map((line, lineIdx) => {
    const hasTrailingNewLine = lineIdx !== lines.length - 1;
    const split = line.split(" ");
    const linkSpans = split.map((s, i) => {
      const hasSpace = i !== split.length - 1;
      if (isSudoziUrl(s)) {
        return (
          <Fragment key={`sudozi-${i}`}>
            <a href={s} key={i}>
              {s}
            </a>
            {hasSpace && " "}
          </Fragment>
        );
      }
      if (isUrl(s)) {
        return (
          <Fragment key={`non-sudozi-${i}`}>
            <a
              href={
                s.startsWith("http")
                  ? s
                  : `${s.startsWith("https") ? `https://${s}` : `http://${s}`}`
              }
              key={i}
              target="_blank"
              rel="noreferrer"
            >
              {s}
            </a>
            {hasSpace && " "}
          </Fragment>
        );
      }

      return (
        <Fragment key={`string-${i}`}>{`${s}${hasSpace ? " " : ""}`}</Fragment>
      );
    });

    return (
      <span key={v4()}>
        {linkSpans}
        {hasTrailingNewLine && "\n"}
      </span>
    );
  });

  return (
    <As
      style={{
        whiteSpace: "pre-wrap",
        wordBreak: "break-word",
      }}
      className={className}
    >
      {withLinks}
    </As>
  );
}
